import { Menu, MenuItem, Typography, Box, styled } from '@mui/material';
import { theme } from '~/shared/styles/theme';
import { ROUTES, QUOIDEN_SUPPORT_EMAIL } from '~/shared/constants';
import LinkOut from '~/assets/icons/LinkOut';

interface Props {
  anchorEl: null | HTMLElement;
  open: boolean;
  onClose: () => void;
  onFamilyTreeClick: () => void;
  onVaultClick: () => void;
  onLogoutClick: () => void;
  onLearnAboutOtcClick: () => void;
  isAdmin: boolean;
  currentPath: string;
}

const ProfileMenuComponent = ({
  anchorEl,
  open,
  onClose,
  onFamilyTreeClick,
  onVaultClick,
  onLogoutClick,
  onLearnAboutOtcClick,
  isAdmin,
  currentPath,
}: Props) => (
  <StyledMenu
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
  >
    {isAdmin && currentPath !== ROUTES.VAULT && (
      <StyledMenuItem onClick={onVaultClick}>
        <MenuItemText>Admin Vault</MenuItemText>
      </StyledMenuItem>
    )}

    {isAdmin && currentPath !== ROUTES.TREE && (
      <StyledMenuItem onClick={onFamilyTreeClick}>
        <MenuItemText>Family Tree</MenuItemText>
      </StyledMenuItem>
    )}

    <StyledMenuItem onClick={onLearnAboutOtcClick}>
      <MenuItemContent>
        <MenuItemText>Learn About OTC</MenuItemText>
        <IconWrapper>
          <LinkOut />
        </IconWrapper>
      </MenuItemContent>
    </StyledMenuItem>

    <StyledMenuItem
      component="a"
      href={`mailto:${QUOIDEN_SUPPORT_EMAIL}`}
      onClick={onClose}
    >
      <MenuItemText>Get Support</MenuItemText>
    </StyledMenuItem>

    <StyledMenuItem onClick={onLogoutClick}>
      <MenuItemText>Logout</MenuItemText>
    </StyledMenuItem>
  </StyledMenu>
);

export default ProfileMenuComponent;

const StyledMenu = styled(Menu)({
  '& .MuiPaper-root': {
    padding: '26px 19px',
    borderRadius: '10px',
    border: `solid 2px ${theme.palette.custom.lightGrayBrown}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: 'none',
  },
});

const StyledMenuItem = styled(MenuItem)<{ component?: 'a'; href?: string }>({
  justifyContent: 'flex-end',
  '&[href]': {
    textDecoration: 'none',
    color: 'inherit',
  },
});

const MenuItemText = styled(Typography)({
  color: theme.palette.custom.textMain,
  fontWeight: 500,
});

const MenuItemContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

const IconWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '8px',
});
